module.exports = __webpack_public_path__ + "static/img/bus-content-2.574e9ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-2.jpg
// module id = KktK
// module chunks = 0